import React, { useState, useEffect } from 'react';
import { Card, Form, Select, Input, InputNumber, Button, message } from 'antd';
import api from '../utils/api';

const { Option } = Select;
const { TextArea } = Input;

const RequestAccess = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await api.get('/api/departments');
      setDepartments(response.data);
    } catch (error) {
      message.error('Failed to fetch departments');
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await api.post('/api/access-requests', values);
      message.success('Access request submitted successfully');
      form.resetFields();
    } catch (error) {
      message.error(error.response?.data?.error || 'Failed to submit access request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Request Access" style={{ maxWidth: 500, margin: '0 auto' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="department_id"
          label="Department"
          rules={[{ required: true, message: 'Please select a department' }]}
        >
          <Select placeholder="Select department">
            {departments.map(dept => (
              <Option key={dept.id} value={dept.id}>
                {dept.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="duration"
          label="Duration (days)"
          rules={[
            { required: true, message: 'Please enter duration' },
            { type: 'number', min: 1, message: 'Duration must be at least 1 day' }
          ]}
        >
          <InputNumber min={1} style={{ width: '100%' }} placeholder="Enter number of days" />
        </Form.Item>

        <Form.Item
          name="reason"
          label="Reason"
          rules={[{ required: true, message: 'Please provide a reason' }]}
        >
          <TextArea
            rows={4}
            placeholder="Why do you need access to this department?"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Submit Request
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default RequestAccess; 